export const formatImage = (
	props: ImageMediaFields & { node?: ImageMediaFields }
): ImageProps => {
	if (!props || (!props?.node && !props?.src)) return null;

	const { altText, mediaDetails, src, ...rest } = props?.node || props;

	return {
		...rest,
		alt: altText,
		height: mediaDetails.height,
		src,
		width: mediaDetails.width,
	};
};
